package flagpack.icons.large

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Brunei Flag (32x24dp)
 *
 * - ISO Alpha-2: BN
 * - ISO Alpha-3: BRN
 * - ISO Numeric: 096
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Large.Brunei: ImageVector by lazy {
    ImageVector.Builder(
        name = "Brunei:BN:BRN:096:Large",
        defaultWidth = 32.dp,
        defaultHeight = 24.dp,
        viewportWidth = 32f,
        viewportHeight = 24f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFD221)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFF313131))) {
                moveTo(-3.067f, 10.615f)
                lineTo(-1.059f, 6.036f)
                lineTo(33.768f, 21.308f)
                lineTo(31.76f, 25.887f)
                lineTo(-3.067f, 10.615f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFAF9F9))) {
                moveTo(-3.017f, 5.569f)
                lineTo(-1.01f, 0.99f)
                lineTo(35.549f, 17.014f)
                lineTo(33.541f, 21.593f)
                lineTo(-3.017f, 5.569f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFCF1225)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.331f, 12.397f)
                curveTo(5.912f, 10.656f, 6.149f, 9.479f, 6.149f, 9.479f)
                curveTo(6.149f, 9.479f, 7.601f, 9.532f, 7.585f, 10.468f)
                curveTo(7.585f, 10.864f, 8.106f, 11.238f, 8.554f, 11.561f)
                curveTo(8.894f, 11.805f, 9.192f, 12.019f, 9.192f, 12.191f)
                curveTo(9.192f, 12.589f, 9.492f, 16.601f, 9.492f, 16.601f)
                curveTo(9.492f, 16.601f, 9.282f, 16.966f, 8.28f, 16.966f)
                curveTo(7.278f, 16.966f, 7.331f, 16.389f, 7.331f, 16.389f)
                curveTo(7.939f, 15.643f, 7.331f, 12.397f, 7.331f, 12.397f)
                close()
                moveTo(24.67f, 12.397f)
                curveTo(26.088f, 10.656f, 25.851f, 9.479f, 25.851f, 9.479f)
                curveTo(25.851f, 9.479f, 24.399f, 9.532f, 24.416f, 10.468f)
                curveTo(24.416f, 10.864f, 23.895f, 11.238f, 23.446f, 11.561f)
                curveTo(23.107f, 11.805f, 22.809f, 12.019f, 22.809f, 12.191f)
                curveTo(22.809f, 12.589f, 22.509f, 16.601f, 22.509f, 16.601f)
                curveTo(22.509f, 16.601f, 22.718f, 16.966f, 23.721f, 16.966f)
                curveTo(24.723f, 16.966f, 24.67f, 16.389f, 24.67f, 16.389f)
                curveTo(24.062f, 15.643f, 24.67f, 12.397f, 24.67f, 12.397f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFCF1225)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(16.06f, 2.875f)
                lineTo(17.187f, 3.679f)
                lineTo(16.448f, 3.876f)
                lineTo(17.187f, 4.515f)
                lineTo(16.267f, 4.282f)
                verticalLineTo(4.926f)
                horizontalLineTo(17.187f)
                lineTo(17.494f, 6.438f)
                lineTo(17.138f, 6.186f)
                lineTo(16.782f, 6.438f)
                lineTo(16.427f, 6.186f)
                lineTo(16.071f, 6.438f)
                lineTo(15.705f, 6.186f)
                lineTo(15.338f, 6.438f)
                lineTo(14.972f, 6.186f)
                lineTo(14.605f, 6.438f)
                lineTo(15.067f, 4.926f)
                horizontalLineTo(15.917f)
                verticalLineTo(2.875f)
                horizontalLineTo(16.06f)
                close()
                moveTo(21.085f, 7.951f)
                curveTo(21.085f, 7.951f, 20.742f, 8.255f, 20.005f, 7.951f)
                curveTo(19.759f, 7.85f, 19.489f, 7.673f, 19.208f, 7.488f)
                curveTo(18.647f, 7.119f, 18.039f, 6.72f, 17.481f, 6.83f)
                curveTo(16.642f, 6.997f, 16.269f, 7.397f, 16.269f, 7.397f)
                verticalLineTo(6.475f)
                horizontalLineTo(16.167f)
                horizontalLineTo(16.01f)
                horizontalLineTo(15.908f)
                verticalLineTo(7.397f)
                curveTo(15.908f, 7.397f, 15.535f, 6.997f, 14.696f, 6.83f)
                curveTo(14.137f, 6.72f, 13.53f, 7.119f, 12.969f, 7.488f)
                curveTo(12.687f, 7.673f, 12.417f, 7.85f, 12.171f, 7.951f)
                curveTo(11.435f, 8.255f, 11.091f, 7.951f, 11.091f, 7.951f)
                curveTo(11.091f, 7.951f, 11.091f, 8.208f, 11.639f, 8.604f)
                curveTo(11.877f, 8.776f, 12.148f, 8.764f, 12.38f, 8.695f)
                curveTo(12.208f, 8.824f, 12.125f, 8.976f, 12.398f, 9.098f)
                curveTo(12.965f, 9.35f, 13.895f, 8.686f, 13.997f, 8.611f)
                curveTo(13.883f, 8.696f, 12.759f, 9.541f, 13.274f, 9.541f)
                curveTo(13.817f, 9.541f, 14.696f, 8.83f, 14.696f, 8.83f)
                curveTo(14.696f, 8.83f, 13.629f, 9.854f, 14.203f, 10.013f)
                curveTo(14.568f, 10.115f, 15.004f, 9.582f, 15.209f, 9.267f)
                curveTo(15.216f, 9.334f, 15.278f, 9.375f, 15.345f, 9.42f)
                curveTo(15.431f, 9.477f, 15.526f, 9.54f, 15.526f, 9.672f)
                curveTo(15.526f, 9.841f, 15.567f, 9.87f, 15.604f, 9.895f)
                curveTo(15.633f, 9.915f, 15.658f, 9.933f, 15.658f, 10.013f)
                verticalLineTo(10.246f)
                lineTo(15.526f, 10.442f)
                curveTo(15.526f, 10.442f, 15.526f, 10.747f, 15.658f, 10.989f)
                curveTo(15.759f, 11.173f, 15.707f, 11.327f, 15.618f, 11.592f)
                curveTo(15.59f, 11.676f, 15.558f, 11.772f, 15.526f, 11.884f)
                curveTo(15.393f, 12.345f, 15.658f, 13.133f, 15.658f, 13.133f)
                horizontalLineTo(15.526f)
                curveTo(15.526f, 13.133f, 15.658f, 13.23f, 15.658f, 13.618f)
                curveTo(15.658f, 13.934f, 15.57f, 14.114f, 15.404f, 14.453f)
                curveTo(15.366f, 14.53f, 15.324f, 14.616f, 15.278f, 14.713f)
                curveTo(15.031f, 15.238f, 15.526f, 15.906f, 15.526f, 15.906f)
                curveTo(15.526f, 15.906f, 14.696f, 15.541f, 14.862f, 15.906f)
                curveTo(14.99f, 16.185f, 15.691f, 16.457f, 16.01f, 16.569f)
                verticalLineTo(16.621f)
                curveTo(16.01f, 16.621f, 16.039f, 16.612f, 16.088f, 16.595f)
                curveTo(16.138f, 16.612f, 16.167f, 16.621f, 16.167f, 16.621f)
                verticalLineTo(16.569f)
                curveTo(16.486f, 16.457f, 17.187f, 16.185f, 17.314f, 15.906f)
                curveTo(17.481f, 15.541f, 16.651f, 15.906f, 16.651f, 15.906f)
                curveTo(16.651f, 15.906f, 17.146f, 15.238f, 16.899f, 14.713f)
                curveTo(16.853f, 14.616f, 16.81f, 14.53f, 16.772f, 14.453f)
                lineTo(16.772f, 14.453f)
                curveTo(16.606f, 14.114f, 16.518f, 13.934f, 16.518f, 13.618f)
                curveTo(16.518f, 13.23f, 16.651f, 13.133f, 16.651f, 13.133f)
                horizontalLineTo(16.518f)
                curveTo(16.518f, 13.133f, 16.784f, 12.345f, 16.651f, 11.884f)
                curveTo(16.619f, 11.772f, 16.587f, 11.676f, 16.558f, 11.592f)
                curveTo(16.469f, 11.327f, 16.417f, 11.173f, 16.518f, 10.989f)
                curveTo(16.651f, 10.747f, 16.651f, 10.442f, 16.651f, 10.442f)
                lineTo(16.518f, 10.246f)
                verticalLineTo(10.013f)
                curveTo(16.518f, 9.933f, 16.544f, 9.915f, 16.572f, 9.895f)
                curveTo(16.609f, 9.87f, 16.651f, 9.841f, 16.651f, 9.672f)
                curveTo(16.651f, 9.54f, 16.746f, 9.477f, 16.832f, 9.42f)
                curveTo(16.899f, 9.375f, 16.961f, 9.334f, 16.967f, 9.267f)
                curveTo(17.172f, 9.582f, 17.608f, 10.115f, 17.973f, 10.013f)
                curveTo(18.547f, 9.854f, 17.481f, 8.83f, 17.481f, 8.83f)
                curveTo(17.481f, 8.83f, 18.36f, 9.541f, 18.902f, 9.541f)
                curveTo(19.418f, 9.541f, 18.293f, 8.696f, 18.179f, 8.611f)
                curveTo(18.281f, 8.686f, 19.212f, 9.35f, 19.778f, 9.098f)
                curveTo(20.051f, 8.976f, 19.968f, 8.824f, 19.797f, 8.695f)
                curveTo(20.028f, 8.764f, 20.3f, 8.776f, 20.538f, 8.604f)
                curveTo(21.085f, 8.208f, 21.085f, 7.951f, 21.085f, 7.951f)
                close()
                moveTo(19.261f, 8.418f)
                curveTo(19.261f, 8.418f, 19.495f, 8.604f, 19.797f, 8.695f)
                curveTo(19.592f, 8.54f, 19.261f, 8.418f, 19.261f, 8.418f)
                close()
                moveTo(16.899f, 9.098f)
                curveTo(16.809f, 8.978f, 16.85f, 9.087f, 16.967f, 9.267f)
                curveTo(16.971f, 9.224f, 16.953f, 9.17f, 16.899f, 9.098f)
                close()
                moveTo(15.278f, 9.098f)
                curveTo(15.368f, 8.978f, 15.326f, 9.087f, 15.209f, 9.267f)
                curveTo(15.205f, 9.224f, 15.224f, 9.17f, 15.278f, 9.098f)
                close()
                moveTo(14.006f, 8.604f)
                curveTo(14.006f, 8.604f, 14.003f, 8.607f, 13.997f, 8.611f)
                curveTo(14.003f, 8.607f, 14.006f, 8.604f, 14.006f, 8.604f)
                close()
                moveTo(12.915f, 8.418f)
                curveTo(12.915f, 8.418f, 12.682f, 8.604f, 12.38f, 8.695f)
                curveTo(12.584f, 8.54f, 12.915f, 8.418f, 12.915f, 8.418f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFCF1225)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(11.229f, 9.578f)
                curveTo(11.229f, 9.578f, 10.036f, 11.202f, 10.168f, 12.936f)
                curveTo(10.301f, 14.671f, 11.717f, 18.707f, 15.916f, 18.707f)
                curveTo(15.952f, 18.707f, 15.988f, 18.706f, 16.023f, 18.706f)
                curveTo(20.473f, 18.706f, 21.736f, 14.256f, 21.736f, 12.656f)
                curveTo(21.736f, 11.042f, 20.729f, 9.578f, 20.729f, 9.578f)
                curveTo(20.729f, 9.578f, 20.847f, 11.744f, 20.729f, 12.656f)
                curveTo(20.374f, 15.406f, 18.642f, 16.677f, 15.994f, 16.677f)
                curveTo(13.329f, 16.677f, 11.681f, 15.358f, 11.229f, 12.656f)
                curveTo(11.083f, 11.782f, 11.229f, 9.578f, 11.229f, 9.578f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFCF1225)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9.066f, 19.751f)
                curveTo(9.066f, 19.751f, 9.282f, 19.131f, 9.549f, 19.131f)
                curveTo(9.815f, 19.131f, 9.039f, 18.592f, 9.549f, 18.44f)
                curveTo(10.058f, 18.288f, 10.842f, 19.047f, 10.842f, 18.288f)
                curveTo(10.842f, 17.528f, 10.179f, 17.114f, 10.666f, 17.114f)
                curveTo(11.154f, 17.114f, 11.662f, 16.969f, 11.662f, 16.969f)
                curveTo(11.662f, 16.969f, 13.735f, 19.131f, 15.811f, 19.131f)
                curveTo(17.886f, 19.131f, 20.382f, 17.114f, 20.382f, 17.114f)
                curveTo(20.382f, 17.114f, 21.302f, 16.88f, 21.302f, 17.245f)
                curveTo(21.302f, 17.61f, 21.1f, 18.16f, 21.1f, 18.16f)
                curveTo(21.1f, 18.16f, 21.745f, 18.033f, 22.073f, 18.16f)
                curveTo(22.401f, 18.288f, 22.073f, 18.896f, 22.073f, 18.896f)
                verticalLineTo(19.131f)
                curveTo(22.073f, 19.131f, 22.926f, 18.943f, 22.926f, 19.279f)
                curveTo(22.926f, 19.615f, 22.514f, 19.423f, 21.68f, 19.519f)
                curveTo(20.845f, 19.615f, 20.528f, 20.268f, 20.004f, 20.268f)
                curveTo(19.479f, 20.268f, 19.366f, 19.751f, 19.366f, 19.751f)
                curveTo(19.366f, 19.751f, 17.742f, 20.632f, 15.811f, 20.632f)
                curveTo(13.88f, 20.632f, 12.714f, 19.751f, 12.714f, 19.751f)
                curveTo(12.714f, 19.751f, 12.896f, 20.655f, 12.279f, 20.462f)
                curveTo(11.662f, 20.268f, 11.031f, 19.039f, 10.29f, 19.279f)
                curveTo(9.549f, 19.519f, 9.066f, 19.751f, 9.066f, 19.751f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF6E017)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(12.062f, 16.165f)
                curveTo(12.098f, 16.131f, 12.135f, 16.093f, 12.183f, 16.041f)
                curveTo(12.319f, 15.893f, 12.356f, 15.854f, 12.384f, 15.836f)
                curveTo(12.39f, 15.861f, 12.393f, 15.903f, 12.393f, 15.959f)
                curveTo(12.393f, 16.336f, 12.407f, 16.62f, 12.443f, 16.818f)
                curveTo(12.47f, 16.958f, 12.506f, 17.05f, 12.57f, 17.093f)
                curveTo(12.663f, 17.157f, 12.758f, 17.101f, 12.845f, 16.97f)
                curveTo(13.046f, 16.669f, 13.423f, 16.632f, 13.423f, 16.746f)
                curveTo(13.423f, 16.776f, 13.411f, 16.808f, 13.338f, 16.988f)
                curveTo(13.325f, 17.019f, 13.315f, 17.044f, 13.306f, 17.068f)
                curveTo(13.255f, 17.204f, 13.232f, 17.301f, 13.243f, 17.386f)
                curveTo(13.259f, 17.514f, 13.353f, 17.585f, 13.505f, 17.585f)
                curveTo(13.673f, 17.585f, 13.784f, 17.476f, 13.907f, 17.261f)
                curveTo(13.919f, 17.24f, 13.951f, 17.182f, 13.964f, 17.157f)
                lineTo(13.965f, 17.157f)
                lineTo(13.965f, 17.157f)
                lineTo(13.971f, 17.146f)
                curveTo(13.993f, 17.105f, 14.009f, 17.078f, 14.025f, 17.057f)
                curveTo(14.069f, 16.995f, 14.079f, 17f, 14.178f, 17.234f)
                curveTo(14.204f, 17.295f, 14.258f, 17.425f, 14.304f, 17.538f)
                curveTo(14.34f, 17.626f, 14.373f, 17.705f, 14.383f, 17.729f)
                curveTo(14.448f, 17.882f, 14.494f, 17.972f, 14.542f, 18.035f)
                curveTo(14.652f, 18.18f, 14.784f, 18.179f, 14.941f, 18.045f)
                curveTo(14.972f, 18.018f, 15.007f, 17.992f, 15.047f, 17.964f)
                curveTo(15.068f, 17.95f, 15.117f, 17.918f, 15.165f, 17.887f)
                lineTo(15.165f, 17.887f)
                curveTo(15.21f, 17.858f, 15.253f, 17.83f, 15.268f, 17.82f)
                curveTo(15.359f, 17.756f, 15.405f, 17.706f, 15.404f, 17.632f)
                curveTo(15.402f, 17.539f, 15.324f, 17.48f, 15.169f, 17.422f)
                curveTo(15.138f, 17.41f, 15.114f, 17.4f, 15.097f, 17.392f)
                lineTo(15.097f, 17.392f)
                lineTo(15.097f, 17.392f)
                curveTo(15.084f, 17.386f, 15.075f, 17.382f, 15.069f, 17.38f)
                curveTo(15.073f, 17.379f, 15.078f, 17.377f, 15.087f, 17.372f)
                lineTo(15.095f, 17.368f)
                curveTo(15.193f, 17.32f, 15.39f, 17.284f, 15.566f, 17.284f)
                lineTo(15.567f, 17.284f)
                curveTo(15.575f, 17.284f, 15.58f, 17.284f, 15.583f, 17.287f)
                curveTo(15.587f, 17.29f, 15.587f, 17.299f, 15.587f, 17.322f)
                lineTo(15.586f, 17.325f)
                curveTo(15.585f, 17.378f, 15.574f, 17.429f, 15.53f, 17.592f)
                lineTo(15.515f, 17.649f)
                curveTo(15.466f, 17.84f, 15.453f, 17.956f, 15.486f, 18.056f)
                curveTo(15.536f, 18.202f, 15.677f, 18.253f, 15.896f, 18.209f)
                curveTo(16.192f, 18.151f, 16.337f, 18.033f, 16.374f, 17.853f)
                curveTo(16.384f, 17.808f, 16.385f, 17.773f, 16.386f, 17.702f)
                curveTo(16.386f, 17.586f, 16.386f, 17.585f, 16.486f, 17.585f)
                curveTo(16.627f, 17.585f, 16.683f, 17.635f, 16.742f, 17.774f)
                curveTo(16.747f, 17.787f, 16.753f, 17.799f, 16.763f, 17.825f)
                curveTo(16.832f, 17.992f, 16.896f, 18.064f, 17.041f, 18.064f)
                curveTo(17.138f, 18.064f, 17.205f, 18.024f, 17.193f, 17.93f)
                curveTo(17.19f, 17.906f, 17.182f, 17.885f, 17.167f, 17.856f)
                lineTo(17.156f, 17.833f)
                lineTo(17.156f, 17.833f)
                curveTo(17.148f, 17.818f, 17.139f, 17.8f, 17.135f, 17.792f)
                curveTo(17.045f, 17.609f, 17.081f, 17.469f, 17.389f, 17.271f)
                curveTo(17.477f, 17.215f, 17.614f, 17.12f, 17.731f, 17.037f)
                lineTo(17.731f, 17.037f)
                lineTo(17.731f, 17.037f)
                lineTo(17.732f, 17.037f)
                curveTo(17.816f, 16.978f, 17.892f, 16.925f, 17.933f, 16.898f)
                curveTo(17.936f, 16.923f, 17.939f, 16.957f, 17.941f, 17.007f)
                curveTo(17.942f, 17.027f, 17.944f, 17.089f, 17.946f, 17.139f)
                lineTo(17.948f, 17.204f)
                curveTo(17.961f, 17.538f, 18.031f, 17.845f, 18.133f, 17.969f)
                curveTo(18.305f, 18.18f, 18.471f, 17.985f, 18.584f, 17.521f)
                curveTo(18.692f, 17.078f, 18.846f, 16.66f, 18.997f, 16.406f)
                curveTo(19.07f, 16.281f, 19.139f, 16.203f, 19.192f, 16.18f)
                curveTo(19.227f, 16.164f, 19.251f, 16.175f, 19.288f, 16.241f)
                curveTo(19.423f, 16.487f, 19.632f, 16.716f, 19.809f, 16.784f)
                curveTo(20.071f, 16.885f, 20.227f, 16.673f, 20.227f, 16.199f)
                curveTo(20.227f, 15.802f, 20.292f, 15.486f, 20.398f, 15.242f)
                curveTo(20.435f, 15.158f, 20.474f, 15.089f, 20.512f, 15.035f)
                curveTo(20.534f, 15.003f, 20.551f, 14.984f, 20.558f, 14.977f)
                lineTo(20.445f, 14.855f)
                curveTo(20.393f, 14.906f, 20.32f, 15.01f, 20.249f, 15.173f)
                curveTo(20.132f, 15.439f, 20.063f, 15.779f, 20.063f, 16.199f)
                curveTo(20.063f, 16.573f, 19.99f, 16.674f, 19.867f, 16.627f)
                curveTo(19.733f, 16.576f, 19.549f, 16.374f, 19.43f, 16.158f)
                curveTo(19.356f, 16.022f, 19.245f, 15.972f, 19.126f, 16.026f)
                curveTo(19.035f, 16.067f, 18.946f, 16.167f, 18.857f, 16.318f)
                curveTo(18.696f, 16.589f, 18.537f, 17.022f, 18.425f, 17.481f)
                curveTo(18.376f, 17.68f, 18.326f, 17.807f, 18.258f, 17.861f)
                curveTo(18.187f, 17.774f, 18.124f, 17.497f, 18.112f, 17.197f)
                lineTo(18.11f, 17.134f)
                lineTo(18.11f, 17.134f)
                curveTo(18.108f, 17.083f, 18.106f, 17.02f, 18.105f, 17f)
                curveTo(18.102f, 16.937f, 18.099f, 16.895f, 18.094f, 16.862f)
                curveTo(18.077f, 16.754f, 18.022f, 16.69f, 17.924f, 16.716f)
                curveTo(17.886f, 16.726f, 17.701f, 16.855f, 17.535f, 16.97f)
                lineTo(17.535f, 16.97f)
                curveTo(17.442f, 17.035f, 17.355f, 17.095f, 17.302f, 17.129f)
                curveTo(16.921f, 17.373f, 16.861f, 17.608f, 16.988f, 17.868f)
                lineTo(16.999f, 17.888f)
                curveTo(16.968f, 17.874f, 16.947f, 17.838f, 16.914f, 17.759f)
                curveTo(16.904f, 17.734f, 16.898f, 17.72f, 16.892f, 17.707f)
                curveTo(16.809f, 17.513f, 16.702f, 17.417f, 16.486f, 17.417f)
                curveTo(16.277f, 17.417f, 16.222f, 17.505f, 16.222f, 17.702f)
                curveTo(16.222f, 17.761f, 16.22f, 17.787f, 16.214f, 17.817f)
                curveTo(16.192f, 17.924f, 16.102f, 17.997f, 15.865f, 18.044f)
                curveTo(15.717f, 18.073f, 15.659f, 18.053f, 15.641f, 18f)
                curveTo(15.622f, 17.944f, 15.633f, 17.85f, 15.674f, 17.692f)
                lineTo(15.689f, 17.636f)
                curveTo(15.736f, 17.456f, 15.749f, 17.402f, 15.75f, 17.328f)
                curveTo(15.753f, 17.202f, 15.691f, 17.116f, 15.566f, 17.116f)
                curveTo(15.367f, 17.116f, 15.147f, 17.156f, 15.024f, 17.217f)
                curveTo(14.822f, 17.317f, 14.862f, 17.487f, 15.113f, 17.58f)
                curveTo(15.162f, 17.598f, 15.195f, 17.614f, 15.215f, 17.624f)
                lineTo(15.215f, 17.624f)
                curveTo(15.229f, 17.631f, 15.236f, 17.634f, 15.239f, 17.633f)
                curveTo(15.237f, 17.634f, 15.232f, 17.638f, 15.225f, 17.644f)
                curveTo(15.214f, 17.652f, 15.198f, 17.665f, 15.176f, 17.681f)
                curveTo(15.164f, 17.689f, 15.126f, 17.713f, 15.084f, 17.74f)
                lineTo(15.084f, 17.74f)
                lineTo(15.084f, 17.74f)
                lineTo(15.084f, 17.74f)
                lineTo(15.084f, 17.741f)
                curveTo(15.034f, 17.772f, 14.979f, 17.808f, 14.955f, 17.824f)
                curveTo(14.911f, 17.855f, 14.872f, 17.885f, 14.836f, 17.915f)
                curveTo(14.744f, 17.994f, 14.718f, 17.994f, 14.671f, 17.932f)
                curveTo(14.634f, 17.883f, 14.593f, 17.802f, 14.533f, 17.662f)
                curveTo(14.523f, 17.638f, 14.492f, 17.562f, 14.456f, 17.474f)
                curveTo(14.409f, 17.361f, 14.355f, 17.229f, 14.328f, 17.167f)
                curveTo(14.187f, 16.833f, 14.035f, 16.759f, 13.892f, 16.957f)
                curveTo(13.873f, 16.985f, 13.854f, 17.017f, 13.828f, 17.062f)
                lineTo(13.821f, 17.076f)
                curveTo(13.807f, 17.102f, 13.776f, 17.157f, 13.765f, 17.176f)
                curveTo(13.67f, 17.343f, 13.595f, 17.417f, 13.505f, 17.417f)
                curveTo(13.43f, 17.417f, 13.41f, 17.402f, 13.405f, 17.364f)
                curveTo(13.399f, 17.316f, 13.417f, 17.239f, 13.459f, 17.129f)
                curveTo(13.467f, 17.106f, 13.477f, 17.083f, 13.489f, 17.053f)
                curveTo(13.58f, 16.829f, 13.587f, 16.812f, 13.587f, 16.746f)
                curveTo(13.587f, 16.405f, 12.983f, 16.465f, 12.71f, 16.875f)
                curveTo(12.687f, 16.91f, 12.667f, 16.933f, 12.653f, 16.944f)
                curveTo(12.639f, 16.922f, 12.62f, 16.867f, 12.604f, 16.786f)
                curveTo(12.57f, 16.602f, 12.557f, 16.325f, 12.557f, 15.959f)
                curveTo(12.557f, 15.727f, 12.488f, 15.605f, 12.338f, 15.671f)
                curveTo(12.27f, 15.702f, 12.267f, 15.704f, 12.064f, 15.925f)
                curveTo(12.019f, 15.975f, 11.984f, 16.01f, 11.952f, 16.04f)
                curveTo(11.909f, 16.08f, 11.873f, 16.108f, 11.841f, 16.125f)
                curveTo(11.794f, 16.149f, 11.776f, 16.134f, 11.751f, 16.025f)
                curveTo(11.725f, 15.913f, 11.717f, 15.755f, 11.717f, 15.49f)
                lineTo(11.717f, 15.38f)
                lineTo(11.717f, 15.266f)
                curveTo(11.717f, 15.078f, 11.667f, 14.973f, 11.545f, 14.973f)
                curveTo(11.503f, 14.973f, 11.461f, 14.987f, 11.408f, 15.014f)
                curveTo(11.389f, 15.024f, 11.369f, 15.035f, 11.343f, 15.05f)
                lineTo(11.333f, 15.056f)
                lineTo(11.278f, 15.088f)
                curveTo(11.165f, 15.152f, 11.09f, 15.181f, 11.019f, 15.181f)
                curveTo(11.006f, 15.181f, 10.998f, 15.184f, 10.995f, 15.184f)
                lineTo(10.995f, 15.184f)
                curveTo(10.993f, 15.185f, 10.993f, 15.185f, 10.993f, 15.185f)
                curveTo(10.993f, 15.185f, 10.993f, 15.184f, 10.994f, 15.183f)
                curveTo(10.997f, 15.179f, 11.005f, 15.17f, 11.014f, 15.151f)
                curveTo(11.061f, 15.06f, 11.186f, 14.912f, 11.387f, 14.715f)
                lineTo(11.274f, 14.593f)
                curveTo(11.06f, 14.803f, 10.926f, 14.961f, 10.869f, 15.074f)
                curveTo(10.79f, 15.229f, 10.851f, 15.35f, 11.019f, 15.35f)
                curveTo(11.126f, 15.35f, 11.221f, 15.312f, 11.357f, 15.235f)
                curveTo(11.514f, 15.145f, 11.522f, 15.141f, 11.545f, 15.141f)
                curveTo(11.545f, 15.141f, 11.554f, 15.159f, 11.554f, 15.266f)
                lineTo(11.553f, 15.379f)
                lineTo(11.553f, 15.49f)
                curveTo(11.553f, 15.768f, 11.562f, 15.935f, 11.592f, 16.065f)
                curveTo(11.638f, 16.264f, 11.752f, 16.361f, 11.916f, 16.274f)
                curveTo(11.962f, 16.25f, 12.01f, 16.213f, 12.062f, 16.165f)
                close()
                moveTo(12.401f, 15.826f)
                curveTo(12.402f, 15.826f, 12.403f, 15.826f, 12.404f, 15.826f)
                lineTo(12.401f, 15.826f)
                close()
                moveTo(15.064f, 17.372f)
                curveTo(15.061f, 17.37f, 15.06f, 17.369f, 15.059f, 17.369f)
                curveTo(15.061f, 17.376f, 15.063f, 17.38f, 15.065f, 17.382f)
                lineTo(15.064f, 17.372f)
                close()
                moveTo(17.965f, 16.879f)
                lineTo(17.963f, 16.879f)
                lineTo(17.965f, 16.879f)
                lineTo(17.965f, 16.879f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF6E017)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(13.833f, 19.75f)
                curveTo(13.76f, 19.946f, 13.645f, 20.011f, 13.516f, 19.913f)
                curveTo(13.476f, 19.883f, 13.438f, 19.841f, 13.384f, 19.772f)
                lineTo(13.373f, 19.757f)
                curveTo(13.344f, 19.719f, 13.274f, 19.627f, 13.248f, 19.594f)
                curveTo(13.136f, 19.455f, 13.04f, 19.368f, 12.935f, 19.324f)
                lineTo(12.926f, 19.32f)
                lineTo(12.926f, 19.32f)
                curveTo(12.798f, 19.265f, 12.771f, 19.254f, 12.744f, 19.241f)
                lineTo(12.715f, 19.227f)
                curveTo(12.561f, 19.152f, 12.474f, 19.074f, 12.39f, 18.93f)
                curveTo(12.324f, 18.816f, 12.26f, 18.663f, 12.152f, 18.366f)
                lineTo(12.306f, 18.307f)
                curveTo(12.41f, 18.594f, 12.472f, 18.742f, 12.531f, 18.843f)
                curveTo(12.597f, 18.958f, 12.66f, 19.014f, 12.785f, 19.075f)
                lineTo(12.811f, 19.087f)
                curveTo(12.837f, 19.1f, 12.863f, 19.111f, 12.989f, 19.165f)
                lineTo(12.989f, 19.165f)
                lineTo(12.998f, 19.168f)
                curveTo(13.133f, 19.226f, 13.247f, 19.329f, 13.374f, 19.487f)
                curveTo(13.402f, 19.523f, 13.478f, 19.622f, 13.504f, 19.656f)
                lineTo(13.504f, 19.656f)
                lineTo(13.513f, 19.668f)
                curveTo(13.557f, 19.725f, 13.588f, 19.759f, 13.613f, 19.778f)
                curveTo(13.626f, 19.788f, 13.627f, 19.789f, 13.625f, 19.79f)
                curveTo(13.637f, 19.783f, 13.657f, 19.751f, 13.679f, 19.69f)
                curveTo(13.73f, 19.555f, 13.686f, 19.45f, 13.563f, 19.34f)
                curveTo(13.559f, 19.336f, 13.546f, 19.326f, 13.53f, 19.313f)
                lineTo(13.53f, 19.313f)
                lineTo(13.53f, 19.313f)
                lineTo(13.53f, 19.313f)
                curveTo(13.483f, 19.276f, 13.405f, 19.213f, 13.39f, 19.191f)
                curveTo(13.343f, 19.122f, 13.383f, 19.051f, 13.455f, 19.032f)
                curveTo(13.488f, 19.024f, 13.535f, 19.021f, 13.612f, 19.021f)
                curveTo(13.877f, 19.021f, 13.95f, 19.176f, 13.999f, 19.574f)
                lineTo(13.999f, 19.58f)
                curveTo(14.038f, 19.894f, 14.077f, 19.98f, 14.211f, 19.98f)
                curveTo(14.362f, 19.98f, 14.454f, 19.92f, 14.614f, 19.748f)
                lineTo(14.649f, 19.711f)
                curveTo(14.854f, 19.493f, 14.997f, 19.42f, 15.238f, 19.486f)
                curveTo(15.43f, 19.54f, 15.512f, 19.634f, 15.531f, 19.781f)
                curveTo(15.533f, 19.797f, 15.534f, 19.809f, 15.536f, 19.837f)
                curveTo(15.546f, 19.96f, 15.568f, 19.98f, 15.807f, 19.98f)
                curveTo(15.988f, 19.98f, 16.157f, 19.989f, 16.377f, 20.009f)
                lineTo(16.403f, 20.011f)
                curveTo(16.455f, 20.016f, 16.565f, 20.026f, 16.598f, 20.028f)
                curveTo(16.669f, 20.034f, 16.72f, 20.037f, 16.76f, 20.037f)
                curveTo(16.789f, 20.037f, 16.811f, 20.036f, 16.826f, 20.033f)
                curveTo(16.832f, 19.985f, 16.861f, 19.951f, 16.976f, 19.821f)
                curveTo(16.989f, 19.806f, 16.999f, 19.794f, 17.009f, 19.783f)
                curveTo(17.062f, 19.72f, 17.086f, 19.677f, 17.085f, 19.67f)
                curveTo(17.084f, 19.669f, 17.036f, 19.652f, 16.907f, 19.652f)
                curveTo(16.787f, 19.652f, 16.728f, 19.637f, 16.717f, 19.553f)
                curveTo(16.708f, 19.483f, 16.749f, 19.449f, 16.839f, 19.401f)
                curveTo(16.942f, 19.346f, 17.13f, 19.274f, 17.355f, 19.203f)
                curveTo(17.573f, 19.134f, 17.802f, 19.071f, 17.976f, 19.035f)
                curveTo(18.07f, 19.015f, 18.147f, 19.003f, 18.203f, 19f)
                curveTo(18.309f, 18.994f, 18.373f, 19.009f, 18.373f, 19.105f)
                curveTo(18.373f, 19.145f, 18.485f, 19.282f, 18.598f, 19.344f)
                curveTo(18.732f, 19.419f, 18.827f, 19.391f, 18.892f, 19.216f)
                curveTo(18.988f, 18.961f, 19.188f, 18.685f, 19.383f, 18.527f)
                curveTo(19.487f, 18.442f, 19.583f, 18.396f, 19.667f, 18.404f)
                curveTo(19.779f, 18.414f, 19.837f, 18.51f, 19.837f, 18.656f)
                horizontalLineTo(19.674f)
                curveTo(19.674f, 18.588f, 19.664f, 18.573f, 19.652f, 18.572f)
                curveTo(19.621f, 18.569f, 19.559f, 18.598f, 19.484f, 18.659f)
                curveTo(19.313f, 18.798f, 19.131f, 19.049f, 19.045f, 19.276f)
                curveTo(18.942f, 19.552f, 18.736f, 19.613f, 18.52f, 19.492f)
                curveTo(18.387f, 19.419f, 18.26f, 19.278f, 18.221f, 19.167f)
                curveTo(18.166f, 19.17f, 18.096f, 19.181f, 18.009f, 19.2f)
                curveTo(17.84f, 19.235f, 17.616f, 19.296f, 17.404f, 19.363f)
                curveTo(17.263f, 19.408f, 17.138f, 19.453f, 17.042f, 19.492f)
                curveTo(17.159f, 19.509f, 17.227f, 19.552f, 17.245f, 19.634f)
                curveTo(17.262f, 19.716f, 17.222f, 19.787f, 17.132f, 19.893f)
                curveTo(17.122f, 19.906f, 17.111f, 19.918f, 17.097f, 19.934f)
                curveTo(17.018f, 20.024f, 16.989f, 20.062f, 16.989f, 20.064f)
                curveTo(16.989f, 20.175f, 16.904f, 20.205f, 16.76f, 20.205f)
                curveTo(16.715f, 20.205f, 16.66f, 20.202f, 16.585f, 20.196f)
                curveTo(16.551f, 20.193f, 16.439f, 20.183f, 16.388f, 20.179f)
                lineTo(16.363f, 20.176f)
                curveTo(16.147f, 20.157f, 15.983f, 20.148f, 15.807f, 20.148f)
                curveTo(15.484f, 20.148f, 15.389f, 20.063f, 15.373f, 19.85f)
                curveTo(15.371f, 19.825f, 15.37f, 19.815f, 15.369f, 19.803f)
                curveTo(15.358f, 19.724f, 15.324f, 19.684f, 15.195f, 19.649f)
                curveTo(15.027f, 19.602f, 14.935f, 19.649f, 14.767f, 19.827f)
                lineTo(14.733f, 19.865f)
                curveTo(14.544f, 20.066f, 14.419f, 20.148f, 14.211f, 20.148f)
                curveTo(13.976f, 20.148f, 13.899f, 20.022f, 13.85f, 19.696f)
                curveTo(13.845f, 19.714f, 13.839f, 19.732f, 13.833f, 19.75f)
                close()
                moveTo(13.846f, 19.601f)
                lineTo(13.845f, 19.595f)
                curveTo(13.83f, 19.492f, 13.814f, 19.412f, 13.793f, 19.353f)
                curveTo(13.874f, 19.455f, 13.903f, 19.568f, 13.862f, 19.696f)
                curveTo(13.856f, 19.666f, 13.851f, 19.635f, 13.846f, 19.601f)
                close()
                moveTo(16.845f, 19.479f)
                lineTo(16.849f, 19.48f)
                lineTo(16.847f, 19.48f)
                lineTo(16.845f, 19.479f)
                close()
                moveTo(16.842f, 20.029f)
                lineTo(16.838f, 20.031f)
                lineTo(16.841f, 20.03f)
                lineTo(16.842f, 20.029f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun BruneiPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Large.Brunei,
            contentDescription = "Brunei Flag"
        )
    }
}
